import { render } from "./BaseAccount.vue?vue&type=template&id=6bb9200e"
import script from "./BaseAccount.vue?vue&type=script&lang=js"
export * from "./BaseAccount.vue?vue&type=script&lang=js"

import "./BaseAccount.vue?vue&type=style&index=0&id=6bb9200e&lang=scss"

import exportComponent from "/var/www/vhosts/t-socialposterexpertise-240125/project/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__